import Vue from 'vue'
import Router from 'vue-router'

import store from '../store/index'
import api from '@/api/index.js';

import login from '@/login/login'
import admin from '@/admin/admin'


//账号管理
import index from '@/admin/nav/index'                                //数据分析
import index2 from '@/admin/nav/index2'                              //首页
import account from '@/admin/nav/account/account'                    //后台账号
import jurisdiction from '@/admin/nav/account/jurisdiction'          //权限
import role from '@/admin/nav/account/role'                          //角色管理
import user from '@/admin/nav/user/user'                             //角色管理
import capital from '@/admin/nav/user/capital'                       //资金账号管理
import goldCoing from '@/admin/nav/user/goldCoing'                   //金币账号管理
import sms from '@/admin/nav/settings/sms'                           //金币账号管理
import classify from '@/admin/nav/novel/classify'                    //小说分类管理
import novel from '@/admin/nav/novel/novel'                          //小说列表管理
import chapter from '@/admin/nav/novel/chapter'                      //小说章节页
import abnormal from '@/admin/nav/settings/abnormal'                 //异常管理
import web from '@/admin/nav/settings/web'                           //页面设置
import hotSearch from '@/admin/nav/settings/hotSearch'               //网站管理
import sitemap from '@/admin/nav/settings/sitemap'                   //网站地图管理
import ConfigurationList from '@/admin/nav/settings/ConfigurationList'                   //网站地图管理
import cache from '@/admin/nav/settings/cache'                      //网站地图管理

import adType from '@/admin/nav/ad/adType'                    //小说分类管理
import ad from '@/admin/nav/ad/ad'                            //小说列表管理

import imgClass from '@/admin/nav/img/imgClass'                    //图片分类管理
import img from '@/admin/nav/img/img'                            //图片列表管理

import bill from '@/admin/nav/bill/'                            //账单列表管理







Vue.use(Router)

//以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/admin',
            name: 'admin',
            redirect: '/admin/account',
            meta: {
                requireAuth: true
            },
            component: admin,
            children: [
                {
                    path: 'index',
                    name: 'index',
                    component: index
                },
                {
                    path: 'index2',
                    name: 'index2',
                    component: index2
                },
                {
                    path: 'account',
                    name: 'account',
                    component: account
                },
                {
                    path: 'jurisdiction',
                    name: 'jurisdiction',
                    component: jurisdiction
                },
                {
                    path: 'role',
                    name: 'role',
                    component: role
                },
                {
                    path: 'user',
                    name: 'user',
                    component: user
                },
                {
                    path: 'goldCoing',
                    name: 'goldCoing',
                    component: goldCoing
                },
                {
                    path: 'capital',
                    name: 'capital',
                    component: capital
                },
                {
                    path: 'sms',
                    name: 'sms',
                    component: sms
                },
                {
                    path: 'classify',
                    name: 'classify',
                    component: classify
                },
                {
                    path: 'novel',
                    name: 'novel',
                    component: novel
                },
                {
                    path: 'chapter',
                    name: 'chapter',
                    component: chapter
                },
                {
                    path: 'abnormal',
                    name: 'abnormal',
                    component: abnormal
                },
                {
                    path: 'web',
                    name: 'web',
                    component: web
                },
                {
                    path: 'hotSearch',
                    name: 'hotSearch',
                    component: hotSearch
                },
                {
                    path: 'sitemap',
                    name: 'sitemap',
                    component: sitemap
                },
                {
                    path: 'ConfigurationList',
                    name: 'ConfigurationList',
                    component: ConfigurationList
                },
                {
                    path: 'cache',
                    name: 'cache',
                    component: cache
                },
                {
                    path: 'adType',
                    name: 'adType',
                    component: adType
                },
                {
                    path: 'ad',
                    name: 'ad',
                    component: ad
                },
                {
                    path: 'bill',
                    name: 'bill',
                    component: bill
                },
                {
                    path: 'imgClass',
                    name: 'imgClass',
                    component: imgClass
                },
                {
                    path: 'img',
                    name: 'img',
                    component: img
                },
                
            ]

        },
    ],
    linkActiveClass: 'active' //更改路由高亮的  类名
})


// 路由发生变化时触发
router.beforeEach((to, from, next) => {
    // 获取登录状态
    let isLogin = store.getters.isLogin
    if (!isLogin) {
        if (to.path !== '/login') {
            return next({
                path: '/login'
            });
        } else {
            next(); // 放行
        }
    } else {
        if (to.path === '/login') {
            return next('/admin/account');
        }
        next();
    }
})

export default router